export default __webpack_public_path__ + "static/media/btn_moreinfo_v.baceabaa.png";